import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    timeout: 120000,
    // SEC-002: cookies must ride along so the server-minted session_id
    // (codex_sid httpOnly cookie) reaches the backend on every request.
    withCredentials: true,
});

export const codexApi = {
    health: () => client.get("/health").then((r) => r.data),
    ask: (query, sessionId, mode = "chat", voiceMode = false, depth = "fast") =>
        client
            .post("/ask", {
                query,
                session_id: sessionId,
                mode,
                voice_mode: voiceMode,
                depth,
            })
            .then((r) => r.data),
    study: (topic, sessionId) =>
        client
            .post("/study", { topic, session_id: sessionId })
            .then((r) => r.data),
    compareWitnesses: (topic) =>
        client.post("/compare-witnesses", { topic }).then((r) => r.data),
    studyPdf: async (packet) => {
        const res = await client.post("/study/pdf", packet, {
            responseType: "blob",
        });
        return res.data;
    },
    tts: async (text, voice = "onyx") => {
        const res = await client.post(
            "/tts",
            { text, voice },
            { responseType: "blob" }
        );
        return res.data;
    },
    transcribe: async (audioBlob, filename = "voice.webm") => {
        const form = new FormData();
        form.append("audio", audioBlob, filename);
        const res = await client.post("/transcribe", form, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 60000,
        });
        return res.data; // { text }
    },
    donationPackages: () => client.get("/donations/packages").then((r) => r.data),
    donationCheckout: ({ packageId, customAmountUsd, originUrl }) =>
        client
            .post("/donations/checkout", {
                package_id: packageId || null,
                custom_amount_usd: customAmountUsd || null,
                origin_url: originUrl,
            })
            .then((r) => r.data),
    donationStatus: (sessionId) =>
        client.get(`/donations/status/${sessionId}`).then((r) => r.data),
};

export function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
